import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class OptionService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getOption(payload) {
    return this._http.get(this.baseUrl + '/admin/optionses/', {
      params: payload.params,
    });
  }
  getPublicOption(payload) {
    return this._http.get(this.baseUrl + '/public/options/', {
      params: payload.params,
    });
  }
  addOption(payload) {
    return this._http.post(this.baseUrl + '/admin/optionses/', payload.body);
  }

  updateOption(payload) {
    return this._http.put(
      `${this.baseUrl}/admin/optionses/${payload.optionTypeId}/`,
      payload.body
    );
  }

  deleteOption(payload) {
    return this._http.delete(
      `${this.baseUrl}/admin/optionses/${payload.optionTypeId}/`
    );
  }
}
